import React, {PropsWithChildren} from 'react';
import AddCodingStamp from './add-coding-stamp/AddCodingStamp';
import {CodingFormItem, ISelectItem} from '../../../../shared/types';
import {useSignalStore} from '../../../PortalPopout/hooks/useSignalStore';
import {
  useDocumentCodingForm,
  useGetEditCodingDetails,
} from '../../../../hooks/document/useDocument';
import {useSelector} from 'react-redux';
import {RootState} from '../../../../redux/store';
import EditCodingForm from '../edit-coding-form/EditCodingForm';

interface CodingFormWrapperProps extends PropsWithChildren {
  panelId: string;
}
export interface CodingStampItem {
  CodingFormStampColorCode: string;
  CodingFormStampColorLabel: string;
  CodingFormStampColorRGB: string;
  CodingFormUserStampID: number;
  CodingFormID: number;
  IsDisabled: boolean;
  SourceID: number;
  CodingFormStampColorName: string;
}

const CodingFormWrapper: React.FC<CodingFormWrapperProps> = ({
  children,
  panelId,
}) => {
  const [isAddStamp, setIsAddStamp] = useSignalStore<boolean>(
    'isAddStamp',
    false
  );
  const [updatedDocumentCodingForm] = useSignalStore<CodingFormItem[]>(
    'updatedDocumentCodingForm',
    []
  );
  const [selectedCodingForm] = useSignalStore<ISelectItem | null>(
    'selectedCodingForm',
    null
  );
  const [codingStamp] = useSignalStore<CodingStampItem[]>('codingStamp', []);
  const [selectedStampId, setSelectedStampId] = useSignalStore<number | null>(
    'selectedStampId',
    null
  );

  const [isEditCodingFormOpen, setIsEditCodingFormOpen] =
    useSignalStore<boolean>('isEditCodingFormOpen', false);

  const {docView, selectedSourceId, activeDocumentObj, sourceId} = useSelector(
    (state: RootState) => ({
      docView: state.docView,
      selectedSourceId: state.docView.sourceId,
      activeDocumentObj: state.docView.activeDoc,
      sourceId: state.docView.sourceId,
    })
  );
  const activeDocumentId = Number(activeDocumentObj?.documentId);

  const payloadCodingForm = {
    codingFormId: Number(selectedCodingForm?.id ?? 0),
    documentId: activeDocumentId,
    assignmentSource: '',
    sourceTypeCode: docView.sourceTypeCode ?? '',
    sourceID: selectedSourceId ? selectedSourceId : 0,
  };
  const {refetch: refetchCodingForm} = useDocumentCodingForm(
    payloadCodingForm,
    Boolean(activeDocumentId && selectedCodingForm?.id)
  );
  const {mutate: getEditCodingDetails} = useGetEditCodingDetails();

  const handleSelectedStampCode = (selectedStampCode: string | null) => {
    if (selectedStampCode) {
      getEditCodingDetails({
        sourceID: sourceId ?? 0,
        CodingFormId: Number(selectedCodingForm?.id ?? 0),
        DocumentId: activeDocumentId,
        Code: selectedStampCode,
        SourceTypeCode: 'DOCUMENT',
      });
    }
  };

  const selectedStamp = codingStamp?.find(
    (stamp) => stamp.CodingFormUserStampID === selectedStampId
  );

  return (
    <>
      {children}
      {isAddStamp && (
        <AddCodingStamp
          panelId={panelId}
          showDrawer={isAddStamp}
          handleDrawer={setIsAddStamp}
          codingForm={updatedDocumentCodingForm}
          codingFormId={Number(selectedCodingForm?.id ?? 0)}
          onSuccess={(data) => {
            refetchCodingForm();
            const stamp = codingStamp.find(
              (cs) => cs.CodingFormStampColorLabel === data.label
            );
            setSelectedStampId(stamp?.CodingFormUserStampID ?? null);
            handleSelectedStampCode(stamp?.CodingFormStampColorCode ?? null);
          }}
        />
      )}

      {isEditCodingFormOpen && (
        <EditCodingForm
          showPanel={isEditCodingFormOpen}
          setShowPanel={setIsEditCodingFormOpen}
          defaultCode={selectedStamp?.CodingFormStampColorCode ?? ''}
          defaultCodingStampName={selectedStamp?.CodingFormStampColorName ?? ''}
          codingFormId={Number(selectedCodingForm?.id ?? 0)}
          onSuccess={refetchCodingForm}
          selectedCodingFormName={
            selectedCodingForm?.name
              ? String(selectedCodingForm.name)
              : undefined
          }
          onCloseDrawer={() => setSelectedStampId(null)}
        />
      )}
    </>
  );
};

export {CodingFormWrapper};
export default CodingFormWrapper;
